import React from 'react';
import styled from '@emotion/styled';
import List from './List';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;

  @media (min-width: ${props => props.theme.breakpoints.m}) and (max-width: ${props => props.theme.breakpoints.l}) {
    padding: 0 20px;
  }

  @media (min-width: ${props => props.theme.breakpoints.s}) and (max-width: ${props => props.theme.breakpoints.m}) {
    width: 90%;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 95%;
  }
`;
const ContentRow = styled.div`
  display: flex;
`;
const Title = styled.div`
  font-size: 15px;
  font-weight: 600;
  min-width: 70px;
  color: ${props => props.theme.colors.black.base};
`;
const Description = styled.p`
  font-size: 12px;
  line-height: 24px;
  margin: 0px 0 25px 0px;
`;

const HealthCareFooterContent = props => {
    return (
        <Section>
            <ContentWrapper>
                {props.content && props.content.map((item, idx) => (
                    <ContentRow key={idx}>
                        <Title>{item.title}</Title>
                        <Description>{item.description}</Description>
                    </ContentRow>
                ))}
            </ContentWrapper>
        </Section>
    );
};

export default HealthCareFooterContent;
